import React, { useState } from 'react';
import './FaqMfd.css';

const FaqMfd = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What is Sales Ninja MFD CRM?',
      answer:'Sales Ninja is an AI-Optimized Lead & Client Management CRM built specifically for Mutual Fund Distributors (MFDs).',
    },

    {
      question: 'What can I manage with Sales Ninja CRM?',
      answer:
        'You can manage: Leads, Follow-ups, Client interactions, Opportunities, Portfolio reviews, Tasks, Client Greetings, Team & User Management, Addon Integrations, All in one place.',
    },

    {
      question: 'Is Sales Ninja CRM built only for MFDs?',
      answer:
        'Yes. The CRM is specially designed around MFD workflows and investor management processes.',
    },

    {
      question:'Can I track SIP & investment opportunities?',
      answer:
        'Yes. You can monitor opportunities, investment amounts, and lead stages from approach to closure.',
    },

    {
      question: 'Is Sales Ninja integrated with wealth management software?',
      answer:
        'Yes. It syncs with your wealth management ecosystem for smoother execution and workflow.',
    },

    {
      question: 'Can teams use Sales Ninja CRM together?',
      answer:
        'Yes. You can create users, manage roles, and control access for team members.',
    },

    {
      question: 'Is training and onboarding provided?',
      answer:
        'Yes. Complete onboarding, training, and support are provided by the RedVision team.',
    },

    {
      question: 'Is there a demo available?',
      answer:
        'Yes. You can book a free live demo to explore the CRM and its features.',
    },

    {
      question: 'Is there any launch offer available?',
      answer:
        'Yes. Special launch offers and referral rewards are currently available for limited periods.',
    },

    {
      question: 'Can I earn through referrals?',
      answer:
        'Yes. Both the Referrer & Buyer can earn rewards on every successful conversion under the referral program.',
    },

  ];

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-mfd-page" id="faqs">
      <div className="faq-mfd-container">
        <div className="faq-kicker">
          <span></span>
          FAQS
        </div>

        <h2 className="faq-title">
          Got Questions?
          <span>
            We&apos;ve Got <em>Answers</em>
          </span>
        </h2>

        <p className="faq-subtitle">
          Everything you need to know about Sales Ninja MFD CRM.
        </p>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
              key={index}
            >
              <button
                type="button"
                className="faq-question"
                onClick={() => handleToggle(index)}
              >
                <span>{faq.question}</span>
                <strong>{openIndex === index ? '−' : '+'}</strong>
              </button>

              <div className="faq-answer-wrap">
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqMfd;